import { FACEBOOK, noop, PINTEREST, SMS } from './catalogConstants';

import { shareViaFacebook, shareViaPinterest, shareViaShareScreen } from '../utils/shareHelpers';

export const getShareOptions = ({ shareMethod, socialShareImgURL, title } = {}) => {
    const url = window.location.href;
    switch (shareMethod) {
        case PINTEREST: {
            return {
                description:
                    'Discover 1stDibs, the world’s leading online marketplace for the most beautiful things on earth.',
                media: socialShareImgURL,
                url,
            };
        }
        case SMS: {
            return {
                title: title || 'Catalog',
                text: 'I wanted to share something beautiful with you!',
                url,
            };
        }
        case FACEBOOK:
        default: {
            return {};
        }
    }
};

export const getShareAction = shareMethod => {
    switch (shareMethod) {
        case FACEBOOK: {
            return shareViaFacebook;
        }
        case PINTEREST: {
            return shareViaPinterest;
        }
        case SMS: {
            return shareViaShareScreen;
        }
        default: {
            return noop;
        }
    }
};
